import { render, staticRenderFns } from "./country-redirect-generic.vue?vue&type=template&id=6c735f3f"
import script from "./country-redirect-generic.vue?vue&type=script&lang=js"
export * from "./country-redirect-generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports